var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "ca7d28588e572ba76bd43ac2b0325012.png",
    width: 50,
    height: 50
});